
import { Box,Alert,AlertIcon,AlertTitle,AlertDescription, Input, Text, Center, Switch } from "@chakra-ui/react";
import { useState,useEffect } from "react";
import { getStanjePoKnjigama,getStanjePoPosjednicima } from "../../util/apiUtil";
import { generateColor, userReadOnly,getMonthDifference } from "../../util/grunt";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar} from "react-chartjs-2";
//import faker from "faker";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
);



export const Stanje02=()=> {
    const [stanjestate,setStanjeState]=useState({labels:[],datasets:[],hasData:false})
    const [datumod,setDatumOd]=useState(new Date(new Date().getFullYear(),new Date().getMonth()-6).toISOString().split("T")[0]);
    const [datumdo,setDatumDo]=useState(new Date().toISOString().split('T')[0]);
    const [stacked,setStacked]=useState(true);
    const [posjednici,setPosjednici]=useState(false);
    const [err,setErr]=useState("");
    useEffect(() => {
      const getData=async()=>{
        let _res;
        if (posjednici) {
          _res=await getStanjePoPosjednicima({_datod:datumod,_datdo:datumdo});
        } else {
          _res=await getStanjePoKnjigama({_datod:datumod,_datdo:datumdo});
        }
        
        if (_res.status===200) {
          //setDbata(_res.res);
          const _r=await adjustData(_res.res);
          if (_r.datasets.length>0) {
            setStanjeState({...stanjestate,labels:_r.labels,datasets:_r.datasets,hasData:true});  
          } else {
            setStanjeState({...stanjestate,hasData:false});
          }
          
          setErr("");
        } else {
          setErr(_res.message);
        }
      }
    getData();
      
    }, [datumod,datumdo,posjednici])
    

    const adjustData=async(_rec)=>{
      const _mjeseci=[];
      const _datasets=[];
      const _posjednici_knjige=[];
      //mjeseci
      for (let i = 0; i < _rec.length; i++) {
        if (_mjeseci.findIndex((item)=>item===_rec[i].mjesec)===-1) {
          _mjeseci.push(_rec[i].mjesec);
        }
      }
      //posjednici_knjige
      for (let i = 0; i < _rec.length; i++) {
        if (_posjednici_knjige.findIndex((item)=>item===_rec[i].posjednik_knjiga)===-1) {
          _posjednici_knjige.push(_rec[i].posjednik_knjiga);
        }
      }
      //datasets new
      let _idx=0;
      for (let _i = 0; _i < _posjednici_knjige.length; _i++) {
        const _posknj=_posjednici_knjige[_i];
        const _data=[];
        for (let _j = 0; _j < _mjeseci.length; _j++) {
          _idx=_rec.findIndex((item)=>item.posjednik_knjiga===_posknj && item.mjesec===_mjeseci[_j]);
          if (_idx===-1) {
            _data.push(0);
          } else {
            _data.push(_rec[_idx].stanje)
          }
        }
        _datasets.push({label:_posknj,data:_data,backgroundColor:generateColor()});
      }
      //datasets
      //let _idx=0;
      /* for (let i = 0; i < _rec.length; i++) {
        
          _idx=_datasets.findIndex((item)=>item.label===_rec[i].posjednik_knjiga);  
        
        
        if (_idx===-1) {
            const _ds={label:_rec[i].posjednik_knjiga,data:[_rec[i].stanje],backgroundColor:generateColor(),}
            _datasets.push(_ds);
        } else {
          _datasets[_idx].data.push(_rec[i].stanje);
        }
      }
 */
      return {labels:_mjeseci,datasets:_datasets}
    }

    const onChangeDate=(event)=>{
      let _v="";
      if (event.target.value.length<=10) {
        _v=event.target.value;
        
        if (event.target.id==="idDatOd") {
          if (getMonthDifference(new Date(_v),new Date(datumdo))<=15) {
            setDatumOd(_v);  
          }
          
        } else {
          if (getMonthDifference(new Date(datumod),new Date(_v))<=15) {
            setDatumDo(_v);  
          }
        }
        
      }
      
    }

    
    const showAlert=()=>{
      if (err!=="") {
        return (
          <Alert status='error'>
            <AlertIcon />
            <AlertTitle>Greška</AlertTitle>
            <AlertDescription>{err}</AlertDescription>
        </Alert>
        )
      }
    }

    const options = {
        responsive: true,
        scales: {
          x: {
            stacked: stacked,
          },
          y: {
            stacked: stacked,
            display:!userReadOnly(),
          },
        },
        plugins: {
          legend: {
            position: "bottom",
            display:posjednici===true && !userReadOnly(),
          },
          title: {
            display: false,
          },
          tooltip:{
            enabled:!userReadOnly(),
          },
        },
      };
       const data = {
        labels:stanjestate.labels,
       
        datasets: stanjestate.datasets ,
      };
  const showData=()=>{
    if (stanjestate.hasData) {
      return(
        
        <Box borderStyle={'solid'} borderWidth={'1px'} bg={'white'} h={'100%'} rounded={'md'} p={'4px'}>
        <Box bg={'grunt2.700'} p={'2px'} mb={'4px'} fontWeight={'normal'} color={'white'} fontSize={'sm'} roundedTopLeft={'md'} roundedTopRight={'md'}>
            Stanje goveda po knjigama/posjednicima
        </Box>
        <Box display={'flex'} flexDirection={'row'} p={'4px'} >
          <Center>
            <Text fontSize={'xs'} mr={'4px'}>Od:</Text>
            <Input focusBorderColor='grunt2.400' id="idDatOd" size={'xs'}  type="date" variant={'outline'} fontWeight={'semibold'}
             value={datumod} onChange={onChangeDate} w={'10rem'} isDisabled={userReadOnly()} placeholder="Datum stanja"/> 
             <Text fontSize={'xs'} ml={'1rem'} mr={'4px'}>Do:</Text>
            <Input focusBorderColor='grunt2.400' id="idDatDo" size={'xs'}  type="date" variant={'outline'} isDisabled={userReadOnly()} fontWeight={'semibold'}
             value={datumdo} onChange={onChangeDate} w={'10rem'} placeholder="Datum stanja"/> 
             <Text fontSize={'xs'} ml={'1rem'} mr={'4px'}>Prikaži zajedno:</Text>
              <Switch id='isChecked' size={'sm'} isChecked={stacked} colorScheme="grunt2" onChange={()=>setStacked(!stacked)} />
              <Text fontSize={'xs'} ml={'1rem'} mr={'4px'}>Posjednici:</Text>
              <Switch id='isChecked' size={'sm'} isChecked={posjednici} colorScheme="grunt2" onChange={()=>setPosjednici(!posjednici)} />
            </Center>
            
        </Box>
        <Box w={'100%'} h={'100%'}>
          <Bar options={options} data={data}/>
        </Box>
        
        {showAlert()}
    </Box>
      )  
    } else {
      return (
      <Box boxShadow={'md'} bg={'white'} rounded={'md'} w={'100%'} h={'100%'} p={'4px'}>
        <Box bg={'grunt2.700'} p={'2px'} mb={'4px'} fontWeight={'normal'} color={'white'} fontSize={'sm'} roundedTopLeft={'md'} roundedTopRight={'md'}>
          Stanje goveda po knjigama/posjednicima
        </Box>
        <Box color={'red'} display={'flex'} flexDir={'column'} alignContent={'center'} p={'4px'} >
            <Center>
            <Box>
            Nema podataka za zadani period
            </Box>
            </Center>
        </Box>
      </Box>
      )
    }
  }
  return (
    showData()
  )
}

